import * as Yup from 'yup';

export const AddEntryFormValidationSchema = () =>
    Yup.object().shape({
        first_name: Yup.string()
            .max(50, 'First name cannot exceed 50 characters.')
            .required('Please enter a first name.'),
        last_name: Yup.string()
            .max(50, 'Last name cannot exceed 50 characters.')
            .required('Please enter a last name.'),
        email: Yup.string()
            .email('Please enter a valid email address.')
            .max(254, 'Email cannot exceed 254 characters.')
            .required('Please enter an email address.'),
        phone_number: Yup.string()
            .required('Please enter a phone number.'),
        is_agree_sms_notification: Yup.string()
            .oneOf(['Yes', 'No'], 'Please select a valid SMS notification preference.')
            .required('Please select SMS notification preference.')
    });

